import { disableScroll } from '../functions/disable-scroll';
import { enableScroll } from '../functions/enable-scroll';

(function(){
  const burger = document?.querySelector('[data-burger]');
  const menu = document?.querySelector('[data-menu]');
  const menuItems = document?.querySelectorAll('[data-menu-item]');
  const overlay = document?.querySelector('[data-menu-overlay]');
  const container = document?.querySelector('[data-menu-container]');
  const filter = document.querySelector('[data-filter]'); 
  const filterBtn = document.querySelector('[data-filter-open]');
  const filterTitle = document.querySelector('.catalog__filter-title--top');

  burger?.addEventListener('click', (e) => {

    burger?.classList.toggle('burger--active');
    
    if(filter?.classList.contains('catalog__filter--active')) {
      filter?.classList.remove('catalog__filter--active')
      burger?.classList.remove('burger--black');
      filterTitle?.classList.remove('catalog__filter-title--top--visible')
      enableScroll();
      return
    }

    menu?.classList.toggle('menu--active');

    if (menu?.classList.contains('menu--active')) {
      burger?.setAttribute('aria-expanded', 'true');
      burger?.setAttribute('aria-label', 'Закрыть меню');
      disableScroll();
    } else {
      burger?.setAttribute('aria-expanded', 'false');
      burger?.setAttribute('aria-label', 'Открыть меню');
      enableScroll();
    }

  });

  menu.addEventListener('click', (e)=>{
    if(!e.composedPath().includes(container)) {
      menu.classList.remove('menu--active');
      burger.classList.remove('burger--active');
      enableScroll();
    }
  })

  overlay?.addEventListener('click', () => {
    burger?.setAttribute('aria-expanded', 'false');
    burger?.setAttribute('aria-label', 'Открыть меню');
    burger.classList.remove('burger--active');
    menu.classList.remove('menu--active');
    enableScroll();
  });

  menuItems?.forEach(el => {
    el.addEventListener('click', () => {
      burger?.setAttribute('aria-expanded', 'false');
      burger?.setAttribute('aria-label', 'Открыть меню');
      burger.classList.remove('burger--active');
      menu.classList.remove('menu--active');
      enableScroll();
    });
  });

  filterBtn?.addEventListener('click', ()=>{
    burger?.classList.add('burger--active');
    burger?.classList.add('burger--black');
    filter?.classList.add('catalog__filter--active');
    filterTitle?.classList.add('catalog__filter-title--top--visible')
    disableScroll();
  })

  // filter?.addEventListener('submit', (e)=>{
  //   e.preventDefault();
  //   filter?.classList.remove('catalog__filter--active')
  //   burger?.classList.remove('burger--black');
  //   filterTitle?.classList.remove('catalog__filter-title--top--visible')
  //   enableScroll();
  // })

})();
